RivalIQ.apps.SocialPosts.module('utils', function (utils, App, Backbone, Marionette, $, _, moment, s) {

    'use strict';

    const MAX_URL_LENGTH = 25;

    function constructAppliedFiltersText(searchTerm, canonicalUrlFilter, postTypeFilter, postTagIds, postTags, dashboardModel, isPPT) {
        let appliedFilters = [];
        if (searchTerm.length) {
            appliedFilters.push(`query: ${searchTerm}`);
        }

        if (!_.isEmpty(postTagIds)) {
            appliedFilters.push(App.utils.makePostTagsText(postTagIds, postTags, true, dashboardModel, isPPT));
        }

        if (canonicalUrlFilter.length) {
            appliedFilters.push(`url: ${s.truncate(canonicalUrlFilter, MAX_URL_LENGTH)}`);
        }

        if (postTypeFilter.length) {
            appliedFilters.push(`type: ${s.capitalize(postTypeFilter)}`);
        }

        appliedFilters = _.compact(appliedFilters);
        if (appliedFilters.length) {
            return [' (', appliedFilters.join(', '), ')'].join('');
        } else {
            return '';
        }
    }

    utils.makePreviewVideoUrl = function (videoUrl) {
        if (videoUrl) {
            if (!_.includes(videoUrl, '#')) {
                // Forward to 2 seconds in for a better key frame
                videoUrl += '#t=2';
            }
        }

        return videoUrl;
    };

    utils.makePostTagsText = function (postTagIds, postTags, lc, dashboardModel, isPPT) {

        const postTagConjunction = dashboardModel.getProp('postTagConjunction') || 'OR';

        const postTagNameProp = (isPPT ? 'tag_name' : 'postTagHtml');
        const postTagsById = _.keyBy(postTags, 'id');
        postTagsById.__UNTAGGED__ = {
            tag_name: 'Untagged',
            postTagHtml: 'Untagged'
        };
        const postTagStrs = _.map(RivalIQ.postTags.utils.getPostTags(postTagIds, postTagsById), postTagNameProp);

        let postTagsStr;
        if (postTagStrs.length === 0) {
            return;
        } else if (postTagStrs.length > 2) {
            postTagsStr = `${_.take(postTagStrs, postTagStrs.length - 2).join(', ')}, ${_.takeRight(postTagStrs, 2).join(`, ${postTagConjunction} `)}`;
        } else {
            postTagsStr = postTagStrs.join(` ${postTagConjunction} `);
        }

        if (dashboardModel.getProp('postTagExclude')) {
            if (isPPT) {
                postTagsStr = `Exclude: ${postTagsStr}`;
            } else {
                postTagsStr = `<strike>${postTagsStr}</strike>`;
            }
        }

        return (lc ? 'post tags: ' : 'Post Tags: ') + postTagsStr;
    };

    /**
     * generates a function for the export title which will include the searchTerm
     */
    utils.exportTitle = function () {
        const me = this;
        const title = _.result(me, 'title');

        if (!me.isFocus() || me.isExportingPPT()) { // PPT export uses a subtitle to show searchTerm
            return title;
        }

        const searchTerm = s.trim(me.getProp('searchTerm'));
        const canonicalUrlFilter = s.trim(me.getProp('canonicalUrlFilter'));
        const postTypeFilter = s.trim(me.getProp('type'));
        const postTagIds = RivalIQ.postTags.utils.getPostTagIds(me.getProp('postTagIds'));
        const postTags = _.get(me, ['curation', 'postTags'], me.postTags);

        return [title, constructAppliedFiltersText(searchTerm, canonicalUrlFilter, postTypeFilter, postTagIds, postTags, me)].join('');
    };

    utils.fetchCompanyData = function () {
        return RivalIQ.data.companyData.fetchPresences();
    };

    // This is async because we need companyData to determine if we have
    // incomplete data
    utils.getSlideElements = function () {
        const me = this;

        return utils.fetchCompanyData().then(function (companyData) {
            me.companyData = companyData;
            return {
                header: {
                    title: me.getTitle(),
                    subtitle: me.getPptSubtitle(companyData)
                }
            };
        });
    };

    utils.pptSubtitle = function (companyData) {
        const me = this;

        const timePeriod = me.getProp('timePeriod');

        const searchTerm = s.trim(me.getProp('searchTerm'));
        const canonicalUrlFilter = s.trim(me.getProp('canonicalUrlFilter'));
        const postTypeFilter = s.trim(me.getProp('type'));
        const postTagIds = RivalIQ.postTags.utils.getPostTagIds(me.getProp('postTagIds'));

        const postTags = _.get(me, ['curation', 'postTags'], me.postTags);
        const timezone = RivalIQ.state.landscape.get('timezone');
        const timePeriodStr = RivalIQ.utils.timePeriod.getTimePeriodDisplayString(timePeriod, null, timezone);
        const incompleteDataWarning = getIncompleteDataString(companyData, me.getProp('channel'), timePeriod);

        return [timePeriodStr, constructAppliedFiltersText(searchTerm, canonicalUrlFilter, postTypeFilter, postTagIds, postTags, me, true), incompleteDataWarning].join(' ');
    };

    utils.exportSubtitle = function (options) {
        const me = this;

        if (!me.isFocus()) {
            return;
        }

        const multiLine = _.get(options, 'multiLine');
        let timePeriod = me.getProp('timePeriod');
        if (me.getProp('timePeriodType')) {
            timePeriod = RivalIQ.state.timePeriods.getByType(me.getProp('timePeriodType'));
        }

        const channel = RivalIQ.props.getChannel(me.getProps());
        const channelName = channel.get('name');

        const incompleteDataWarning = getIncompleteDataString(me.companyData, me.getProp('channel'), timePeriod);

        // fancy formats like PDF headers need the individual elements
        // everyone else just wants a reasonably formatted string
        const timezone = RivalIQ.state.landscape.get('timezone');
        if (multiLine) {
            return [
                channelName,
                RivalIQ.utils.timePeriod.getTimePeriodDisplayString(timePeriod, null, timezone),
                incompleteDataWarning
            ];
        } else {
            return [
                channelName,
                ', ',
                RivalIQ.utils.timePeriod.getTimePeriodDisplayString(timePeriod, null, timezone),
                incompleteDataWarning
            ].join('');
        }
    };

    function getIncompleteDataString(companyData, channel, timePeriod) {
        const periodStart = timePeriod.mainPeriodStart;
        const companiesWithIncompleteData = App.utils.findCompaniesWithIncompleteData(companyData, channel, periodStart);
        if (!_.isEmpty(companiesWithIncompleteData)) {
            return ' (Incomplete data)';
        } else {
            return '';
        }
    }

    utils.findCompaniesWithIncompleteData = function (companyData, channel, periodStart) {
        if (!companyData) {
            return [];
        }

        const source = RivalIQ.data.channels.get(channel).get('source');
        return companyData.reduce(function (memo, company) {
            const incompleteDate = company.getIncompletePostDataDate(source, periodStart);
            if (incompleteDate) {
                memo.push({
                    companyId: company.id,
                    latestFetchDate: incompleteDate
                });
            }
            return memo;
        }, []);
    };

    utils.validCurationOptions = [
        'channel',
        'type',
        'tweetType',
        'tweetTypeFilter',
        'instanceId',
        'promotedPosts',
        'domainModeFilter',
        'canonicalUrlExactMatch',
        'postTagIds',
        'postTagConjunction',
        'postTagExclude',
        'mustHavePostTagIds',
        'fromCurationId',
        'fromCurationCompanyId'
    ].concat(_.keys(RivalIQ.enums.searchFieldNames));

    utils.validWidgetOptions = utils.validCurationOptions.concat([
        'orderBy',
        'sortOrder',
        'limit',
        'dimension',
        'layout',
        'rowExpansions',
        'isInPostTagEditMode',
        'showPostTags',
        'from'
    ]);

    utils.widgetExportProps = utils.validWidgetOptions;

    utils.validQueryParams = _.without(utils.validWidgetOptions.concat([
        'landscapeId',
        'focusCompanyId',
        'companySetDescriptor',
        'timezone',
        'companyIds',
        'domainsOnly',
        'excludePostsWithoutLinks',
        'startDate',
        'endDate',
        'engagementFloor',
        'metricValues',
        'minimumDesiredResults',
        'activeSources',
        'includeDimensionResults',
        'includeObservations',
        'hashtagsMinPosts',
        'hashtagsMinCompanies',
        'keywordsOnly',
        'keywordsMinPosts',
        'keywordsMinCompanies',
        'keywordsMinWords',
        'keywordsScoreRankCutoff',
        'postIds',
        'limitPostTagIds',
        'postAutoTagId',
        'includeSummaryRow',
        'includePosts',
        'includeBreakdowns',
        'canModifyDateRange',
        'compareStartDate',
        'compareEndDate'
    ]), 'instanceId', 'isInPostTagEditMode');

    utils.validPostedUrlSortQueryParams = _.reduce(['canonicalUrl', 'primaryDomain', 'companyIdPrimaryDomain', 'companyIdCanonicalUrl'], function (memo, dimension) {
        return memo.concat([
            `${dimension}Limit`,
            `${dimension}OrderBy`,
            `${dimension}SortOrder`
        ]);
    }, []);
    utils.validPostedUrlQueryParams = utils.validQueryParams.concat(utils.validPostedUrlSortQueryParams);

    utils.dimensionsWithServerSideSort = [
        'post',
        'hashtag',
        'keyword',
        'primaryDomain',
        'canonicalUrl',
        'post_tag_id'
    ];

    utils.dimensionsNeedServerSideSort = function (dimensions) {
        return _.some(dimensions, function (dimension) {
            return _.includes(App.utils.dimensionsWithServerSideSort, dimension);
        });
    };

    utils.isGridLayout = function (propable, fn) {
        return utils.isGridLayoutFromProps({
            layout: propable.getProp('layout')
        }, fn);
    };

    // true for Top Bottom Grids & regular Grid layouts
    utils.isGridBasedLayout = function (propable, fn) {
        return utils.isGridLayout(propable, fn) || utils.isTopBottomLayout(propable, fn);
    };

    utils.isTopBottomLayout = function (propable, fn) {
        return utils.isTopBottomLayoutFromProps({
            layout: propable.getProp('layout')
        }, fn);
    };

    utils.isGridLayoutFromProps = function (props, fn) {
        const layout = props.layout;
        const types = _.values(RivalIQ.views.SocialPostGrid.types);
        return _.includes(types, layout) && (!fn || fn(layout));
    };

    utils.isTopBottomLayoutFromProps = function (props, fn) {
        const layout = props.layout;
        const types = _.values(RivalIQ.views.TopBottomLayout.types);
        return _.includes(types, layout) && (!fn || fn(layout));
    };

    utils.isGridDetailsLayout = function (propable) {
        return utils.isGridLayout(propable, function (layout) {
            return Boolean(layout.match(/with_details/));
        });
    };

    utils.isTopBottomDetailsLayout = function (propable) {
        return utils.isTopBottomLayout(propable, function (layout) {
            return Boolean(layout.match(/with_details/));
        });
    };

    utils.isGridSquareLayout = function (propable) {
        return utils.isGridLayout(propable, function (layout) {
            return Boolean(layout.match(/square/));
        });
    };

    utils.gridExportFormats = function () {
        const me = this;
        const visualExports = [
            RivalIQ.enums.exportFormat.PDF,
            RivalIQ.enums.exportFormat.PPT,
            RivalIQ.enums.exportFormat.PNG
        ];

        if (!App.utils.isTopBottomLayout(me)) {
            return visualExports.concat(RivalIQ.enums.exportFormat.CSV);
        }

        return visualExports;
    };

    utils.updateMetric = function (metric, props) {
        props = _.pick(props, _.without(utils.validQueryParams, 'orderBy').concat('timePeriod'));
        _.extend(metric.attributes, props, {
            startDate: moment.utc(props.timePeriod.mainPeriodStart).format('YYYY-MM-DD'),
            endDate: moment.utc(props.timePeriod.mainPeriodEnd).format('YYYY-MM-DD')
        });
    };

    utils.getOrderBy = function (propable) {
        // NOTE default to Engagement Total if we couldn't find an `orderBy`
        let definition = {
            channel: propable.getProp('channel'),
            dimensions: ['post'],
            property: 'engagement_total'
        };

        const orderBy = propable.getProp('orderBy');
        if (_.isFinite(orderBy)) {
            const metricsCollection = _.get(propable, ['dashboardModel', 'metricsCollection'], propable.metricsCollection);
            const metric = metricsCollection.at(orderBy);
            // NOTE it is possible that `metric` will not exist so we must be
            // ever vigilant...
            if (metric) {
                definition = metric.toType();
            }
        } else if (_.isObject(orderBy)) {
            definition = orderBy;
        } else if (_.get(RivalIQ.enums.sourceDetails, [propable.getProp('source'), 'privateData']) && _.isString(orderBy)) {
            definition.property = orderBy;
        }

        return definition;
    };

    utils.getActivityNouns = function (props) {
        const channel = RivalIQ.data.channels.get(props.channel);
        const noun = s.capitalize(channel.get('postName'));
        return {
            singular: noun,
            plural: `${noun}s`
        };
    };

    utils.getPostedUrlsRedactedChannels = function () {
        // NOTE: if you change this list, be sure to update the list of available channels in #postedUrlsChannelRedactedErrorTemplate
        // and the source mask manipulation in searchServices.normalizeSearchOptions().
        return [
            RivalIQ.enums.channels.INSTAGRAM,
            RivalIQ.enums.channels.TIKTOK,
            RivalIQ.enums.channels.YOUTUBE
        ];
    };

    utils.getSelectedPostTagIdsArray = function (postTagIdsStr) {
        const ids = RivalIQ.postTags.utils.getPostTagIds(postTagIdsStr);
        return _(ids)
            .map(function (id) {
                const numeric = Number(id);
                return (_.isNaN(numeric) ? id : numeric);
            })
            .value()
            .sort();
    };

    utils.getShortcodeFromPostLink = function (postlink) {
        // instagram postlinks looks like: https://www.instagram.com/p/CTkninelsLF
        return (postlink || '').split('/')[4].split('?')[0];
    };

    utils.shouldUseCdnThumbnail = function (useThumbnailUrl, thumbnailUrl) {
        return useThumbnailUrl && !RivalIQ.utils.BrokenThumbnailHandler.isBrokenThumbnailUrl(thumbnailUrl);
    };

    utils.showPostTagsManager = function (dashboardModel, clickSourceInfo, additionalProps) {

        if (RivalIQ.utils.browser.isMobile() || RivalIQ.utils.browser.isTablet()) {
            const modalInfo = {
                contentHtml: Marionette.TemplateCache.get('#postTagsMobileModal')()
            };
            RivalIQ.execute('show:modal', modalInfo);
            return;
        }

        const curation = dashboardModel.getCuration();

        RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ClickedViewPostTagManager, clickSourceInfo);

        const props = _.pick(curation.getProps(), RivalIQ.apps.SocialPosts.utils.validCurationOptions);

        const path = curation.router.resolveCurationRoute(RivalIQ.enums.curation.POSTTAGSMANAGER, _.extend(props, {
            instanceId: null,
            from: curation.getPath()
        }, additionalProps));

        Backbone.history.navigate(path, {
            trigger: true
        });
    };

    utils.setupSearchTipsPopover = function (curationId, domEl, options) {

        const popoverOptions = _.extend({
            content: Marionette.TemplateCache.get('#searchTipsPopoverTemplate')({}),
            html: true,
            container: domEl,
            placement: 'bottom',
            trigger: 'hover'
        }, options);

        domEl.on('click', function () {
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ClickedSearchTips, {
                curationId: curationId
            });
        });

        domEl.popover(popoverOptions);


        domEl.on('shown.bs.popover', function () {
            domEl.find('.popover').on('click', function (e) {
                // swallow the click event, unless the user clicked on the link in the popover.
                if (!$(e.target).is('a')) {
                    e.preventDefault();
                }
            });
        });
    };

    utils.canUseTopBottomGrids = function (curationId) {
        const availableCurationIds = [
            RivalIQ.enums.curation.POSTTAGS,
            RivalIQ.enums.curation.SOCIALPOSTS,
            RivalIQ.enums.curation.COMPANY_SOCIALPOSTS,
            RivalIQ.enums.curation.FACEBOOK_INSIGHTS_POSTS,
            RivalIQ.enums.curation.INSTAGRAM_INSIGHTS_POSTS,
            RivalIQ.enums.curation.LINKEDIN_INSIGHTS_POSTS,
            RivalIQ.enums.curation.TWITTER_INSIGHTS_POSTS
        ];
        return _.includes(availableCurationIds, curationId);
    };

    utils.getDefaultLayoutByChannel = function (channel, curationId) {
        let defaultLayout;
        if (_.includes([RivalIQ.enums.channels.INSTAGRAM, RivalIQ.enums.channels.YOUTUBE], channel)) {
            defaultLayout = RivalIQ.views.SocialPostGrid.types.gridWithDetails;
        }

        const socialPostLayouts = RivalIQ.state.user.get('lastSelectedSocialPostsLayout');
        const layout = _.get(socialPostLayouts, [channel], defaultLayout);
        if (!utils.canUseTopBottomGrids(curationId) && _.includes(layout, RivalIQ.views.TopBottomLayout.types.topBottomsPosts)) {
            return RivalIQ.views.SocialPostGrid.types.grid;
        }
        return layout;
    };

    utils.updateUserChannelLayout = function (channel, layout) {
        const socialPostLayouts = RivalIQ.state.user.get('lastSelectedSocialPostsLayout');
        // NOTE this will allow for keys named `undefined` in the Cross Channel
        // case
        socialPostLayouts[channel] = layout;
        RivalIQ.state.user.set({
            lastSelectedSocialPostsLayout: socialPostLayouts
        });
    };

    utils.getPostMediaTypeFilterItems = function (source) {
        switch (source) {
            case RivalIQ.enums.sources.FACEBOOK_INSIGHTS:
                return [
                    {
                        name: 'All Media',
                        id: undefined
                    },
                    {
                        name: 'Link',
                        id: 'link'
                    },
                    {
                        name: 'Status',
                        id: 'status'
                    },
                    {
                        name: 'Photo',
                        id: 'photo'
                    },
                    {
                        name: 'Reel',
                        id: 'reel'
                    },
                    {
                        name: 'Video',
                        id: 'video'
                    },
                    {
                        name: 'Live Video',
                        id: 'live_video'
                    },
                    {
                        name: 'Offer',
                        id: 'offer'
                    }
                ];

            case RivalIQ.enums.sources.INSTAGRAM:
            case RivalIQ.enums.sources.INSTAGRAM_INSIGHTS:
                return [
                    {
                        id: undefined,
                        name: 'All Media'
                    },
                    {
                        id: 'photo',
                        name: 'Photo'
                    },
                    {
                        id: 'video',
                        name: 'Video'
                    },
                    {
                        id: 'carousel',
                        name: 'Carousel'
                    },
                    {
                        id: 'reel',
                        name: 'Reel'
                    }
                ];

            case RivalIQ.enums.sources.LINKEDIN:
                return [
                    {
                        name: 'All Media',
                        id: undefined
                    },
                    {
                        name: 'Article',
                        id: 'ARTICLE'
                    },
                    {
                        name: 'Photo',
                        id: 'PHOTO'
                    },
                    {
                        name: 'None',
                        id: 'NONE'
                    },
                    {
                        name: 'Rich',
                        id: 'RICH'
                    },
                    {
                        name: 'Video',
                        id: 'VIDEO'
                    },
                    {
                        name: 'Learning',
                        id: 'LEARNING'
                    },
                    {
                        name: 'Job',
                        id: 'JOB'
                    },
                    {
                        name: 'Question',
                        id: 'QUESTION'
                    },
                    {
                        name: 'Answer',
                        id: 'ANSWER'
                    },
                    {
                        name: 'Carousel',
                        id: 'CAROUSEL'
                    },
                    {
                        name: 'Topic',
                        id: 'TOPIC'
                    }
                ];

            case RivalIQ.enums.sources.TWITTER:
            case RivalIQ.enums.sources.TWITTER_INSIGHTS:
                return [
                    {
                        name: 'All Media',
                        id: undefined
                    },
                    {
                        name: 'GIF',
                        id: 'gif'
                    },
                    {
                        name: 'Link',
                        id: 'link'
                    },
                    {
                        name: 'Photo',
                        id: 'photo'
                    },
                    {
                        name: 'Status',
                        id: 'status'
                    },
                    {
                        name: 'Video',
                        id: 'video'
                    }
                ];

            default:
                return [
                    {
                        name: 'All Media',
                        id: undefined
                    },
                    {
                        name: 'GIF',
                        id: 'gif'
                    },
                    {
                        name: 'Link',
                        id: 'link'
                    },
                    {
                        name: 'Photo',
                        id: 'photo'
                    },
                    {
                        name: 'Status Update',
                        id: 'status'
                    },
                    {
                        name: 'Video',
                        id: 'video'
                    }
                ];
        }
    };

    utils.createNumericFilterDropdown = function (config) {
        return Marionette.ItemView.mixin({
            template: '#numericFilterDropdownTemplate',

            attributes: {
                style: 'width: 100%'
            },

            behaviors: {
                DropdownSelector: {
                    prop: config.prop,
                    propDefaultValue: config.propDefaultValue
                }
            },

            mixins: {
                props: Marionette.Dashboard.mixins.Props
            },

            serializeData: function () {
                const min = _.get(config, ['min'], 1);
                const selectableNumbers = _.range(min, config.max + 1);
                return {
                    label: config.label,
                    selectableItems: _.map(selectableNumbers, function (number) {
                        return {
                            id: number,
                            name: number.toString()
                        };
                    })
                };
            },

            onSelectDropdown: function (data) {
                const me = this;
                _.defer(function () {
                    me.setProps(config.prop, parseInt(data.itemId));
                });
            }
        });
    };

    utils.attachVideoOnLoadHandlers = function ($el) {
        const videos = $el.find('video');
        videos.each(function (idx, video) {
            video.addEventListener('canplaythrough', function () {
                $(video).removeClass('x-video-loading');
            });
        });
    };


    // The metric model's _convertSparseDayDataToChartValues and getTicks methods use the keys of RivalIQ.utils.timePeriod.interval
    // as the interval prop instead of the values, so make sure we're converted to the correct value.
    utils.fixIntervalForMetric = function (interval) {

        if (RivalIQ.utils.timePeriod.interval[interval]) {
            return interval;
        }

        const oldIntervalKey = _.findKey(RivalIQ.utils.timePeriod.interval, value => value === interval);

        return oldIntervalKey || RivalIQ.utils.timePeriod.interval.daily;
    };

    utils.arePostsFiltered = function (dashboardModel) {

        if (!dashboardModel) {
            return false;
        }

        const props = dashboardModel.getProps();

        // check for any search terms
        let postsFiltered = _.some(RivalIQ.enums.searchFieldNames, function (searchFieldName) {
            return Boolean(_.size(props[searchFieldName.fieldName]));
        });

        // check for any other filters types applied
        const otherFilters = [
            'postTagIds',
            'type', // media type
            'tweetType'
        ];
        postsFiltered = postsFiltered || _.some(otherFilters, function (filterPropName) {
            return Boolean(_.size(props[filterPropName]));
        });

        return postsFiltered;
    };

    utils.shouldShowLink = function (post) {
        let showLink = !_.isEmpty(_.get(post.get('display'), ['link']));
        if (showLink && post.get('source') === RivalIQ.enums.sources.FACEBOOK) {
            showLink = _.includes(['link', 'video'], post.get('type'));
        }

        return showLink;
    };

}, window.moment, window.s);
